/**
 * One definition of "notes to sign" (dentist role test, finding 19): Home's
 * "Notes to sign" count and the Notes due page read the same query, the
 * Unsigned tab for the same provider scope and date range, so the tile never
 * says 4 while the page it opens says 0.
 */
export type QueueProviderScope = 'me' | 'all';

/** Days back the queue looks by default (the page's "Last 30 days"). */
export const NOTES_QUEUE_DEFAULT_DAYS = 30;

/** Clinicians who sign see their own notes; everyone else sees the office's. */
export function defaultQueueProvider(canSign: boolean): QueueProviderScope {
  return canSign ? 'me' : 'all';
}

function addDays(iso: string, n: number): string {
  const d = new Date(`${iso}T00:00:00Z`);
  d.setUTCDate(d.getUTCDate() + n);
  return d.toISOString().slice(0, 10);
}

/** The local calendar date (the queue's "to"). */
export function localToday(now: Date = new Date()): string {
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
}

export function queueRange(
  today: string,
  days: number = NOTES_QUEUE_DEFAULT_DAYS,
): { from: string; to: string } {
  return { from: addDays(today, -days), to: today };
}

/** The Home tile label for the scope ("My notes to sign" when it is yours). */
export function notesTileLabel(scope: QueueProviderScope): string {
  return scope === 'me' ? 'My notes to sign' : 'Notes to sign';
}
